import React from "react";
import { Link } from "react-router-dom";
import LogoutPage from './Logout';
import profileImg from "../../../images/profile/17.png";
import { Dropdown } from "react-bootstrap";
import { connect } from 'react-redux';
const Header = ({ onNote, toggle, onProfile, onNotification, onClick, profile,walletBalance }) => {
  return (
    <div className="header">
		<div className="header-content">
			<nav className="navbar navbar-expand">
				<div className="collapse navbar-collapse justify-content-between">
						
					<div className="header-left">
						<div className="dashboard_bar">
							<div className="input-group search-area d-lg-inline-flex d-none">
								{/* <div className="input-group-append">
									<button className="input-group-text"><i className="flaticon-381-search-2"></i></button>
								</div>
								<input type="text" className="form-control" placeholder="Search here..." /> */}
							</div>
						</div>
					</div>

					<ul className="navbar-nav header-right">
						<li className="nav-item">
							<div className="d-flex weather-detail">
								<span><i className="la la-rupee"></i>{(walletBalance && walletBalance.currentBalance) ? walletBalance.currentBalance : 0 }</span>
								₹ {(walletBalance && walletBalance.utilizedBalance) ? walletBalance.utilizedBalance : 0 }
							</div>
						</li>

						
						
						<Dropdown as="li" className="nav-item header-profile ">
							<Dropdown.Toggle
							  as="a"
							  to="#"
							  variant=""
							  className="nav-link i-false c-pointer"
							>
								<div className="header-info">
									<span className="text-black">Hello,<strong>{profile.name}</strong></span>
									<p className="fs-12 mb-0">{profile.type}</p>
								</div>
								<img src={profileImg} width={15} alt="" />
							</Dropdown.Toggle>
							<Dropdown.Menu align="end" className="mt-2">
							  <Link to="/profile" className="dropdown-item ai-icon">
								<svg
								  id="icon-user1"
								  xmlns="http://www.w3.org/2000/svg"
								  className="text-primary"
								  width={18}
								  height={18}
								  viewBox="0 0 24 24"
								  fill="none"
								  stroke="currentColor"
								  strokeWidth={2}
								  strokeLinecap="round"
								  strokeLinejoin="round"
								>
								  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
								  <circle cx={12} cy={7} r={4} />
								</svg>
								<span className="ms-2">Profile </span>
							  </Link>
							 
							  <LogoutPage />
							</Dropdown.Menu>
						</Dropdown>
					</ul>
				</div>
			</nav>
		</div>
    </div>
  );
};
const mapStateToProps = (state) => {
	return {
		profile: state.profile.profile,
		walletBalance: state.merchantBalance.walletBalance,
	};
};
export default connect(mapStateToProps)(Header);
